import React, { memo } from "react";
import PropTypes from "prop-types";

import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

const DEFAULT_ROWS_PER_PAGE = [5, 10, 25, 50, 100];

export const Pagination = memo(function Pagination(props) {
  const {
    rowCount,
    casesCount,
    pageSize,
    pageIndex,
    handlePageChange,
    handleRowsPerPageChange,
    TablePaginationActions
  } = props;

  const rowsPerPage = Number.isNaN(Number(pageSize)) ? rowCount : pageSize;
  const page = Number.isNaN(Number(pageIndex)) ? rowCount : pageIndex;
  const rowsPerPageOptions = !rowCount ? [0] : DEFAULT_ROWS_PER_PAGE;

  return (
    <Table>
      <TableFooter>
        <TableRow>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            colSpan={3}
            count={casesCount}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
              inputProps: { "aria-label": "rows per page" }
            }}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            ActionsComponent={TablePaginationActions}
          />
        </TableRow>
      </TableFooter>
    </Table>
  );
});

Pagination.propTypes = {
  rowCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  pageIndex: PropTypes.number.isRequired,
  casesCount: PropTypes.number.isRequired,
  handlePageChange: PropTypes.func.isRequired,
  handleRowsPerPageChange: PropTypes.func.isRequired,
  TablePaginationActions: PropTypes.elementType.isRequired
};
